import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { TableOutline } from '../../elements'
import {
  getTableHeadings,
  incentiveStructureOptions,
  PROGRAMS
} from './constant'
import { programService } from '../../Services/ProgramService'
import { DialogActions, DialogContent, DialogContentText, Grid, Box } from '@material-ui/core'
import * as messageTypes from '../../utils/messageTypes'
import DisplayMessage from '../../Components/DisplayMessage'
import { COMMON } from '../../utils/constants'
import { useStyles } from './style'
import Towerimg from '../../Assets/Images/electric-tower.svg'
import { AppButton, ComponentLoader, Loader } from '../../Components'
import CustomDialog from '../../Components/CustomDialog'
import Icon from '../../utils/icons'
import moment from 'moment'
import { timeZoneAbbrs } from '../../utils/momentTimezones'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function ProgramsRequests(props) {
  const classes = useStyles()
  const [requestData, setRequestData] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState([])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(messageTypes.INFO)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [buttonDisabled, setButtonDisabled] = useState(false)

  const incentiveStructure = {
    'UPFRONT_DISCOUNT': 'Upfront Discount Incentive Value',
    'SEASONAL_PERFORMANCE_INCENTIVES': 'Seasonal Performance Incentive Value',
    'CUSTOM': 'Incentive Value'
  }

  const getProgramsRequests = (page, rowsPerPage) => {
    const { account_id } = props.currentUser
    const params = {
      'status': 'pending', page: page - 1,
      size: props.page ? 3 : rowsPerPage
    }
    programService.getAllPrograms(account_id, params)
      .then(requestData => {
        setRequestData(requestData.programs)
        setTotalCount(_.get(requestData, 'total_count', 0))
        setRequestTable(requestData.programs)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  }

  const setRequestTable = (requestData) => {
    let requestTable = []
    requestData.map(obj => {
      let tableObj = [
        {
          id: 'programName',
          value: _.get(obj, 'program_object.program_name_admin_ui', '-'),
          program_id: _.get(obj, 'program_id', ''),
          handleClick: (obj) => handleRowClick(obj, requestData),
          className: props.page && props.page === 'admin' && classes.nameInTable,
        },
        {
          id: 'accountName',
          value: _.get(obj, 'account_name', '-'),
          className: props.page && props.page === 'admin' && classes.nameInTable,
        },
        {
          id: 'requestedBy',
          value: _.get(obj, 'program_object.requested_by', '-')
        },
        ...(!props.page ? [{
          id: 'date&time',
          value: obj && obj.program_object && obj.program_object.creation_date_time ? moment.tz(obj.program_object.creation_date_time, props.timeZone).format('Do MMM YYYY h:mm A zz') : 'Not Available'
        }] : []),
      ]
      requestTable.push(tableObj)
    })
    setTableData(requestTable)
  }

  const handleRowClick = (obj, requestData) => {
    let selected = requestData.filter((data, index) => data.program_id === obj.program_id)
    setSelectedRequest(selected[0])
    setButtonDisabled(false)
    setOpenModal(true)
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
    setLoading(true)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    setLoading(true)
  }

  const getFieldValue = (selectedRequest) => {
    return selectedRequest && selectedRequest.program_object && Object.values(selectedRequest.program_object.incentive_structure)[0]
  }

  const renderIcon = (value) => {
    if (_.isUndefined(value) && !buttonDisabled) {
      setButtonDisabled(true)
    }
    return !_.isUndefined(value) ? <></> : <Icon src="circleCross" />
  }

  const getModalContent = () => (
    <>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Grid container spacing={4}>
            <Grid item sm={12}>
              <div className={classes.cardData}>Requested By</div>
              <span className={classes.cardValue}><img src={Towerimg} style={{ verticalAlign: 'middle' }} /> {_.get(selectedRequest, 'account_name', '-')}</span>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <div className={classes.cardData}>Name of Program</div>
              <span className={classes.cardValue}>{selectedRequest && selectedRequest?.program_object && selectedRequest?.program_object?.program_name_admin_ui}</span>
              <span className={classes.circleIcon}>{renderIcon(selectedRequest && selectedRequest.program_object && selectedRequest.program_object.program_name_admin_ui)}</span>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.cardData}>Incentive Structure</div>
              <span className={classes.cardValue}>{selectedRequest && selectedRequest.program_object && incentiveStructureOptions[Object.keys(selectedRequest.program_object.incentive_structure)[0]]}</span>
              <span className={classes.circleIcon}>{renderIcon(selectedRequest && selectedRequest.program_object && Object.keys(selectedRequest.program_object.incentive_structure)[0])}</span>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <div className={classes.cardData}>State</div>
              <span className={classes.cardValue}>{_.get(selectedRequest, 'program_object.state', '-')}</span>
              <span className={classes.circleIcon}>{renderIcon(_.get(selectedRequest, 'program_object.state', undefined))}</span>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.cardData}>{selectedRequest && selectedRequest.program_object && incentiveStructure[Object.keys(selectedRequest.program_object.incentive_structure)[0]]}</div>
              <span className={classes.cardValue}>{getFieldValue(selectedRequest)}</span>
              <span className={classes.circleIcon}>{renderIcon(selectedRequest && selectedRequest.program_object && Object.values(selectedRequest.program_object.incentive_structure)[0])}</span>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <div className={classes.cardData}>Utility Name</div>
              <span className={classes.cardValue}>{_.get(selectedRequest, 'program_object.utility_name', '-')}</span>
              <span className={classes.circleIcon}>{renderIcon(_.get(selectedRequest, 'program_object.utility_name', undefined))}</span>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.cardData}>Maximum enrollment</div>
              <span className={classes.cardValue}>{_.get(selectedRequest, 'program_object.max_system_enrollments', '-')}</span>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <div className={classes.cardData}>Program End Date</div>
              <span className={classes.cardValue}>{_.get(selectedRequest, 'program_object.program_end_date') ? moment(selectedRequest?.program_object?.program_end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '-'}</span>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.cardData}>Program Configuration Settings</div>
              <span className={classes.cardValue}>{'Default'}</span>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <Box>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <AppButton text="Approve" onClick={() => approveRequest(selectedRequest)} disabled={buttonDisabled} />
        </DialogActions>
      </Box>
    </>
  )

  const approveRequest = (data) => {
    let obj = { program_status: 'approved', programId: data.program_id }
    setLoading(true)
    programService.approveProgramRequest(obj, props.currentUser.account_id)
      .then(requestData => {
        setMessage('Program approved successfully')
        setOpen(true)
        setMessageType(messageTypes.SUCCESS)
        setOpenModal(false)
        getProgramsRequests(page, rowsPerPage)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }

  const rejectRequest = (data) => {
    // let obj = { approval_status: 'REJECTED', email: data.email }
    // requestService.rejectRequest(obj, props.currentUser.account_id)
    //   .then(requestData => {
    //     setMessage(requestData)
    //     setOpen(true)
    //     setMessageType(messageTypes.SUCCESS)
    //     setOpenModal(false)
    //     getAllRequests(props.currentUser.account_id)
    //     setLoading(false)
    //   })
    //   .catch(error => error)
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  useEffect(() => {
    getProgramsRequests(page, rowsPerPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage])

  return (
    <>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      {!props.page && <Loader loading={loading} />}
      {selectedRequest && <CustomDialog open={openModal} fullWidth maxWidth="sm" title="New Program Details" content={getModalContent()} handleClose={handleClose} />}
      {loading && props.page ? <ComponentLoader loading={loading} style={{ height: 230 }} /> :
        <TableOutline
          tableHeadings={props.columns || getTableHeadings(PROGRAMS)}
          tableData={tableData}
          totalElement={totalCount}
          loading={loading}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          pagination={!props.page}
        />}
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, timeZone } = auth
  return { authUser, currentUser, timeZone }
}

export default connect(mapStateToProps)(ProgramsRequests)